import { build } from "../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/reports",
		component: lazy(() => import("./CarrierReports")),
	},
]);
